import axios from 'axios';
import authConfig from "../environment/config";
import { appConst } from "../constant/constant";
import CryptoJS from 'crypto-js';
import { AppType } from "../constant/appType";

export const msalToken = "msal.idtoken";
export const FORGOTPASSWORDAPI = '/api/utility/ForgotPassword'
export const REGISTERUSERAPI = '/api/register/NewUser?hiddenParam='
export const USEREXISTSAPI = '/api/User/GetADUser'
export const GETUNIFYID = '/api/utility/GetUnifyId'
export const UNLOCKUSER = '/api/utility/SignInAttempts'
export const CHECK_USER_VERIFY = '/api/utility/CheckUserVerified'
export const VERIFYUSER = '/api/register/update'
export const newUserHiddenGUID = '752b2c5e-464a-4348-92f9-6398010cea85'

export const api = {
  encryption: {
    IV: "8080808080808080",
    Key: "8080808080808080"
  }
}

export const clearUMCache = () => {
  const cacheKeys = ["msal.idtoken", "apiUrl", "uiUrl", "redirectAppUri", "updateSignIn", "applicationConfig", "usertype"];
  cacheKeys.forEach(key => {
    localStorage.removeItem(key);
  });
};

// Get template data 
export const GetAppTempleateData = (appConfig, callback) => {
  let baseUrl = `${authConfig.storageUri}apps/`;
  if (appConfig && appConfig.appClientId && appConfig.appClientId !== 'null' && appConfig.appClientId !== appConst.EmptyGuid) {
    baseUrl = baseUrl + appConfig.appClientId + '/app-template.json?v=';
    axios.get(baseUrl + Math.floor(Math.random() * 100))
      .then(function (response) {
        callback(response.data);
      })
      .catch(error => {
        console.log('Details: ', error);
        callback(null);
      });
  } else {
    //baseUrl = baseUrl + 'app-template.json?v=';
    callback(null);
  }
};


//Get all countries
export const GetAllCountries = async () => {
  return await axios.get(`https://countriesnow.space/api/v0.1/countries`);
};

export const GetCountryStates = async (obj, callback) => {
  // Get all country's states
  await axios.post(`https://countriesnow.space/api/v0.1/countries/states`, obj)
    .then(res => {
      callback(res.data);
    });
};

export const GetStateCities = async (obj, callback) => {
  // Get all states's cities
  await axios.post(`https://countriesnow.space/api/v0.1/countries/state/cities`, obj)
    .then(res => {
      if (res && res.data && res.data.data.length === 0) {
        res.data.data = ["Other"];
      }
      callback(res.data);
    })
    .catch(error => {
      console.error('Error occurred', error);
    })
};

export const ForgotPasswordApiCall = async (config, obj, callback) => {
  const baseApi = (config.apiUrl && config.apiUrl.indexOf("qa") !== -1) ? authConfig.api.qa : authConfig.api.development;
  await axios.post(`${baseApi}${FORGOTPASSWORDAPI}`, obj, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }).then(res => {
    callback(res.data);
  })
};

export const IsUserExists = async (config, email, userType = 1, callback) => {
  const baseApi = (config.apiUrl && config.apiUrl.indexOf("qa") !== -1) ? authConfig.api.qa : authConfig.api.development;
  const apiUrl = baseApi + USEREXISTSAPI + `?email=${email}&userType=${userType}`; //(config.apiUrl.indexOf("qa") !== -1)?  authConfig.api.qa : authConfig.api.development;
  axios.get(apiUrl)
    .then(function (response) {
      callback(response.data);
    })
    .catch(error => {
      console.log('Details: ', error);
      callback(null);
    });
};

export const GetUnifyId = async (config, email, callback) => {
  const baseApi = (config.apiUrl && config.apiUrl.indexOf("qa") !== -1) ? authConfig.api.qa : authConfig.api.development;
  await axios.post(`${baseApi}${GETUNIFYID}?email=${email}`, null,
    {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': 'CCRAppshub@2024', //Provide Authorization key to be validate din backend  => AuthApiKey from Secret Manager
      }
    }).then(res => {
      callback(res.data);
    })
    .catch(error => {
      console.error('Error occurred', error);
    })
};

export const UnlockAccount = async (email, code = '', isUnlock = false, appType = '', callback) => {
  let apiUrl = authConfig.api.development + UNLOCKUSER
  if (isUnlock)
    apiUrl += `?email=${encodeURIComponent(email)}&code=${encodeURIComponent(code)}&IsAccountUnlock=${isUnlock}`;
  else
    apiUrl += appType !== AppType.CSS ? `?email=${email}` : `?email=${email}&appType=${appType}`;

  axios.post(apiUrl, null, {
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'apiKey': encryptData('C@rrierapphub2018'),
    }
  }).then(function (response) {
    callback(response.data);
  }).catch(error => {
    console.log('Details: ', error);
    callback(null);
  });
};

export const encryptData = (data) => {
  let key = CryptoJS.enc.Utf8.parse(api.encryption.Key);
  let iv = {
    keySize: 128 / 8,
    iv: CryptoJS.enc.Utf8.parse(api.encryption.IV),
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  };
  return encodeURIComponent(CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key, iv));
}

export const registerNewUserAPI = async (config, obj, callback, errCallBack) => {
  const baseApi = (config.apiUrl && config.apiUrl.indexOf("qa") !== -1) ? authConfig.api.qa : authConfig.api.development;
  await axios.post(`${baseApi}${REGISTERUSERAPI}${encryptData(newUserHiddenGUID)}&AppURL=${config.uiUrl}`, obj, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }).then(res => {
    callback(res.data);
  }).catch(err => {
    errCallBack(err);
  })
};

export const accountVerificationAPI = async (config, obj, callback) => {
  const baseApi = (config.apiUrl && config.apiUrl.indexOf("qa") !== -1) ? authConfig.api.qa : authConfig.api.development;
  await axios.put(`${baseApi}${VERIFYUSER}`, obj, {
    method: 'PUT',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    }
  }).then(res => {
    callback(res.data);
  }).catch(err => {
    console.log(err)
  })
};

export const checkVerificationAPI = async (config, email, callback, errCallback) => {
  const baseApi = (config.apiUrl && config.apiUrl.indexOf("qa") !== -1) ? authConfig.api.qa : authConfig.api.development;
  await axios.post(`${baseApi}${CHECK_USER_VERIFY}?email=${encodeURIComponent(email)}`, null, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'Authorization': 'CCRAppshub@2024', //Provide Authorization key to be validate din backend  => AuthApiKey from Secret Manager
    }
  }).then(res => {
    callback(res.data);
  }).catch(err => {
    errCallback(err);
  })
};
